<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-desempenho titulo="Desempenho Técnico">
      <template v-slot:body>
        <v-col
          centered
          cols="12"
          no-gutters
        >
          <!-- prazo esgotado -->
          <v-row v-if="!prazoDisponivel">
            <v-col>
              <app-alert
                icon="watch_later"
                message="O prazo para visualização ainda não está disponível."
                type="info"
              />
            </v-col>
          </v-row>

          <!-- prazo não esgotado -->
          <div v-else>
            <!-- abas -->
            <v-row
              v-if="desempenhoLoaded"
              class="justify-center ma-2"
            >
              <v-tabs
                v-model="currentCategoriaId"
                centered
                icons-and-text
              >
                <v-tabs-slider color="secondary" />
                <v-tab
                  v-for="c in categorias"
                  :key="c.id"
                  :href="`#${c.id}`"
                  class="mt-3"
                >
                  <span class="grey--text text--darken-2">{{
                    c.descricao
                  }}</span>
                  <v-icon
                    :color="c.id === currentCategoriaId ? 'secondary' : 'grey'"
                  >
                    {{ c.icone }}
                  </v-icon>
                </v-tab>
              </v-tabs>
            </v-row>

            <!-- conteúdo das abas -->
            <v-row
              v-if="desempenhoLoaded"
              class="justify-center ma-2"
            >
              <!-- caso tenha avaliação -->
              <v-col v-if="teveAvaliacao">
                <keep-alive>
                  <component
                    :is="currentComponent"
                    :key="currentCategoria.id"
                    :desempenho="desempenho"
                    :tipo="currentCategoria.id"
                  />
                </keep-alive>
              </v-col>

              <!-- caso não tenha -> mostrar motivo -->
              <v-col v-else>
                <app-alert
                  :message="motivoNaoTeveAvaliacao"
                  type="info"
                />
              </v-col>
            </v-row>
          </div>
        </v-col>
      </template>
    </app-desempenho>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppDesempenho from '@/components/core/AppDesempenho';
import AppAlert from '@/components/core/AppAlert';
import ResultadoAgrupado from '@/components/desempenho/ResultadoAgrupadoResponsabilidade';
import ResultadoAvaliacao from '@/components/desempenho/ResultadoAvaliacaoResponsabilidade';
import Data from '@/modules/data';

export default {
  name: 'DesempenhoResponsabilidade',

  components: {
    AppDesempenho,
    AppAlert,
    ResultadoAvaliacao,
    ResultadoAgrupado,
  },

  data() {
    return {
      currentCategoriaId: 'ResultadoAvaliacao',
      categorias: [
        {
          id: 'AUTOAVALIACAO',
          descricao: 'Autoavaliação',
          icone: 'person',
          component: 'ResultadoAvaliacao',
        },
        {
          id: 'GESTOR',
          descricao: 'Avaliação do Gestor',
          icone: 'work',
          component: 'ResultadoAvaliacao',
        },
        {
          id: 'AGRUPADO',
          descricao: 'Meu Resultado',
          icone: 'speed',
          component: 'ResultadoAgrupado',
        },
      ],
    };
  },

  computed: {
    ...mapState({
      diagnostico: (state) => state.diagnostico.diagnostico,
      diagnosticos: (state) => state.diagnostico.diagnosticos,
      desempenho: (state) => state.desempenho.desempenho,
      usuario: (state) => state.auth.usuario,
      unidade: (state) => state.auth.unidade,
      isTutorialExibido: (state) => state.tutorial.dados.desempenhoResponsabilidade,
      desempenhoLoaded: (state) => state.desempenho.loaded,
    }),
    teveAvaliacao() {
      switch (this.currentCategoriaId) {
        case 'AUTOAVALIACAO':
          return this.desempenho.teveAutoavaliacaoResponsabilidade;
        case 'GESTOR':
          return this.desempenho.teveAvaliacaoGestorResponsabilidade;
        case 'AGRUPADO':
          return (
            !this.desempenho.foiDispensado
            && this.desempenho.teveAutoavaliacaoResponsabilidade
            && this.desempenho.teveAvaliacaoGestorResponsabilidade
          );
        default:
          return true;
      }
    },
    currentComponent() {
      return this.currentCategoria.component || '';
    },
    currentCategoria() {
      return this.categorias.find((c) => c.id === this.currentCategoriaId) || {};
    },
    motivoNaoTeveAvaliacao() {
      let motivo = '';
      switch (this.currentCategoriaId) {
        case 'AUTOAVALIACAO':
          return this.desempenho.motivoNaoTeveAutoavaliacaoResponsabilidade;
        case 'GESTOR':
          return this.desempenho.motivoNaoTeveAvaliacaoGestorResponsabilidade;
        case 'AGRUPADO':
          if (this.desempenho.foiDispensado) {
            return this.desempenho.motivoNaoTeveAutoavaliacaoResponsabilidade;
          }

          if (
            !this.desempenho.teveAutoavaliacaoResponsabilidade
            || !this.desempenho.teveAvaliacaoGestorResponsabilidade
          ) {
            motivo += 'Resultado inviabilizado.';
            if (!this.desempenho.teveAutoavaliacaoResponsabilidade) {
              motivo += ` (${this.desempenho.motivoNaoTeveAutoavaliacaoResponsabilidade})`;
            }
            if (!this.desempenho.teveAvaliacaoGestorResponsabilidade) {
              motivo += ` (${this.desempenho.motivoNaoTeveAvaliacaoGestorResponsabilidade})`;
            }
          }
          return motivo;
        default:
          return '';
      }
    },
    prazoDisponivel() {
      if (this.diagnostico === null) {
        return null;
      }
      return Data.compare('isSameOrAfter', { b: this.diagnostico.inicioDesempenho, precisao: 'days' });
    },
  },

  watch: {
    diagnostico() {
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.prazoDisponivel && this.diagnosticos.length > 0) {
        if (!this.desempenhoLoaded) {
          this.$store.dispatch('desempenho/load', { diagnostico: this.diagnostico });
        }
        if (!this.isTutorialExibido) {
          this.$store.dispatch('app/showTutorial', { nome: 'DesempenhoResponsabilidade' });
        }
      }
    },
  },
};
</script>
